import { render } from "./isfc.vue?vue&type=template&id=f6a65958&scoped=true"
import script from "./isfc.vue?vue&type=script&lang=js"
export * from "./isfc.vue?vue&type=script&lang=js"

import "./isfc.vue?vue&type=style&index=0&id=f6a65958&lang=less&scoped=true"

import exportComponent from "/Users/aa/work/credit_chakra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6a65958"]])

export default __exports__